<template>
  <div class="text-center mb-10">
    <p v-if="eyebrow" class="text-sm font-semibold uppercase tracking-[0.25em] text-golden-grass-400">
      {{ eyebrow }}
    </p>
    <h2 class="mt-2 text-3xl sm:text-4xl font-bold text-marshland-50">{{ title }}</h2>
    <p v-if="description" class="mt-3 text-lg text-marshland-300">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  eyebrow?: string
  description?: string
}>()
</script>
